import { ChangeEventHandler, FC, ReactNode } from "react";
import "./style.scss";
import ArrowBottom from "@/src/svg/header/ArrowBottom";

interface ISelectDefault {
  reverse?: boolean;
  children: ReactNode;
  value: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
}

const SelectDefault: FC<ISelectDefault> = ({ children, value, onChange, reverse }) => {
  return (
    <div className={`select-default ${reverse ? "reverse" : ""}`}>
      <select onChange={onChange} value={value}>
        {children}
      </select>
      <ArrowBottom />
    </div>
  );
};

export default SelectDefault;
